module.exports = __webpack_public_path__ + "static/media/5d639cc3.jpg";